module.exports = __webpack_public_path__ + "superhero-banner-half-bluewp6fdba422a0f653a9cafd5971963f6507.png";